import { SvgIconComponent } from '@mui/icons-material';
import {
	Assignment as TaskIcon,
	BusinessCenter as InstrumentIcon,
	Folder as ProjectIcon,
	Category as GeneralIcon,
	FileCopy as FileIcon,
	Note as NoteIcon,
	InsertDriveFile as InsertDriveFileIcon,
	ContentCopy as SelectionIcon,
} from '@mui/icons-material';

export enum ItemType {
	INSTRUMENT = 'INSTRUMENT',
	FILE = 'FILE',
	TASK = 'TASK',
	NOTE = 'NOTE',
	PROJECT = 'PROJECT',
	SELECTION = 'SELECTION',
}

export interface SelectedItem {
	id: string;
	name: string;
	type?: ItemType;
	webUrl?: string;
}

export interface SelectedItemsListProps {
	items: SelectedItem[];
	onRemove: (id: string) => void;
	type?: ItemType;
}

export const getIconForType = (type: ItemType): SvgIconComponent => {
	switch (type) {
		case ItemType.TASK:
			return TaskIcon;
		case ItemType.INSTRUMENT:
			return InstrumentIcon;
		case ItemType.PROJECT:
			return ProjectIcon;
		case ItemType.FILE:
			return FileIcon;
		case ItemType.NOTE:
			return NoteIcon;
		case ItemType.SELECTION:
			return SelectionIcon;
		default:
			return GeneralIcon;
	}
};
